<template>
  <transition name="slideDown">
    <modal title="Add Destinations" v-if="show">
      <div class="form-horizontal">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group">
              <label for="name"
                class="col-sm-2 control-label">
                Name
              </label>

              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  v-model="optionForm.destinations.name">
              </div>
            </div>

            <div class="form-group">
              <label for="slug"
                class="col-sm-2 control-label">
                Slug
              </label>

              <div class="col-sm-10">
                <input
                  type="text"
                  class="form-control"
                  id="slug"
                  placeholder="Slug"
                  v-model="optionForm.destinations.slug">
              </div>
            </div>

            <div class="form-group">
              <label for="parent"
                class="col-sm-2 control-label">
                Parent
              </label>

              <div class="col-sm-10" style="z-index: 9999;">
                <treeselect
                  placeholder="Select parent"
                  v-model="optionForm.destinations.parent"
                  value-format="object"
                  id="optionForm"
                  ref="destinationAddOption"
                  :multiple="false"
                  :options="list.destinations"
                  :load-options="loadOptions"
                  :auto-load-root-options="false">
                </treeselect>
              </div>
            </div>

            <div class="form-group">
              <label for="image"
                class="col-sm-2 control-label">
                Image
              </label>

              <div class="col-sm-10">
                <FileGallery
                  type="destinations"
                  :inline="true"
                  @update-images="setImage"
                  :selected="optionForm.destinations.image" />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 text-right">
            <button class="btn btn-primary"
              @click="$emit('add')">
              Add
            </button>
          </div>
        </div>
      </div>
    </modal>
  </transition>
</template>

<script>
import FileGallery from '@/components/modules/common/FileGallery';
import Modal from '@/components/modules/common/Modal';
import { Treeselect, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';

export default {
  props: {
    optionForm: {
      type: Object,
      required: true,
    },

    list: {
      type: Object,
      required: true,
    },

    show: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    FileGallery,
    Modal,
    Treeselect,
  },

  methods: {
    async loadOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        if (this.destinationListUpdated) {
          await this.fetchDestination();
          this.destinationListUpdated = false;
        }
      }
    },

    setImage(payload) {
      this.$emit('setImage', payload);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/products/partials/ModalDestinations.vue